import { COUNTRY_CODES } from '../constants/shipping.constants';
import { ServerName } from '../interfaces/server-name';
export let WarehouseSystem = /*#__PURE__*/function (WarehouseSystem) {
  WarehouseSystem["RAPID_LOGISTICS"] = "RAPID_LOGISTICS";
  WarehouseSystem["FULFILLIFY"] = "FULFILLIFY";
  WarehouseSystem["WHIPLASH"] = "WHIPLASH";
  WarehouseSystem["BR"] = "BR";
  return WarehouseSystem;
}({});
export let ComplemarOrderStatus = /*#__PURE__*/function (ComplemarOrderStatus) {
  ComplemarOrderStatus["shipped"] = "Closed";
  ComplemarOrderStatus["backOrdered"] = "Backordered";
  ComplemarOrderStatus["cancelled"] = "Cancelled";
  return ComplemarOrderStatus;
}({});
export let WhiplashOrderStatus = /*#__PURE__*/function (WhiplashOrderStatus) {
  WhiplashOrderStatus["shipped"] = "Shipped";
  WhiplashOrderStatus["backOrdered"] = "Insufficient Inventory";
  WhiplashOrderStatus["cancelled"] = "Cancelled";
  return WhiplashOrderStatus;
}({});
export let WhiplashOrderType = /*#__PURE__*/function (WhiplashOrderType) {
  WhiplashOrderType["direct_to_consumer"] = "direct_to_consumer";
  WhiplashOrderType["dropship"] = "dropship";
  WhiplashOrderType["retail"] = "retail";
  WhiplashOrderType["transfer"] = "transfer";
  WhiplashOrderType["wholesale"] = "wholesale";
  return WhiplashOrderType;
}({});
export let WarehouseSource = /*#__PURE__*/function (WarehouseSource) {
  WarehouseSource["Swag"] = "Swag";
  return WarehouseSource;
}({});
export let WarehouseAdvanceShipmentNoticeStatus = /*#__PURE__*/function (WarehouseAdvanceShipmentNoticeStatus) {
  WarehouseAdvanceShipmentNoticeStatus["CREATED"] = "Created";
  WarehouseAdvanceShipmentNoticeStatus["IN_TRANSIT"] = "In Transit";
  WarehouseAdvanceShipmentNoticeStatus["DELIVERED"] = "Delivered";
  WarehouseAdvanceShipmentNoticeStatus["IN_STOCK"] = "In Stock";
  return WarehouseAdvanceShipmentNoticeStatus;
}({});
export const PrefixReduction = {
  [ServerName.prod]: 'P',
  [ServerName.staging]: 'S',
  [ServerName.test1]: 'T1',
  [ServerName.test2]: 'T2',
  [ServerName.test3]: 'T3',
  [ServerName.test4]: 'T4',
  [ServerName.test5]: 'T5',
  [ServerName.test6]: 'T6',
  [ServerName.test7]: 'T7',
  [ServerName.test8]: 'T8',
  [ServerName.test9]: 'T9',
  [ServerName.testAuto]: 'TA',
  [ServerName.testIts]: 'TI',
  [ServerName.test11]: 'T11',
  [ServerName.development]: 'D'
};
export let WarehouseDistributionArea = /*#__PURE__*/function (WarehouseDistributionArea) {
  WarehouseDistributionArea["EastCoast"] = "EastCoast";
  WarehouseDistributionArea["WestCoast"] = "WestCoast";
  WarehouseDistributionArea["International"] = "International";
  WarehouseDistributionArea["USA"] = "USA";
  WarehouseDistributionArea["NotAvailable"] = "NotAvailable";
  return WarehouseDistributionArea;
}({});
export let WarehouseCodes = /*#__PURE__*/function (WarehouseCodes) {
  WarehouseCodes["ROC"] = "ROC";
  WarehouseCodes["MEC"] = "MEC";
  WarehouseCodes["WHIPLASH"] = "WHIPLASH";
  WarehouseCodes["POSTAL"] = "POSTAL";
  WarehouseCodes["BR"] = "BR";
  return WarehouseCodes;
}({});
export const CUSTOM_INK_DEFAULT_WAREHOUSE_SYSTEM = WarehouseSystem.BR;
export const CUSTOM_INK_DEFAULT_WAREHOUSE_CODE = WarehouseCodes.BR;
export const FULFILLIFY_WAREHOUSES = [WarehouseCodes.ROC, WarehouseCodes.MEC];
export const WHIPLASH_WAREHOUSES = [WarehouseCodes.WHIPLASH];
export const BR_WAREHOUSES = [WarehouseCodes.BR];
export const WAREHOUSE_CODES_LABELS = {
  [WarehouseCodes.ROC]: 'ROC - Complemar',
  [WarehouseCodes.MEC]: 'MEC - Complemar',
  [WarehouseCodes.WHIPLASH]: 'Whiplash',
  [WarehouseCodes.BR]: 'BR Printers'
};
export const ALL_WAREHOUSES_OPTION = {
  label: 'All warehouses',
  value: 'ALL'
};
export const WAREHOUSE_CODES_OPTIONS = Object.values(WarehouseCodes).map(value => ({
  label: WAREHOUSE_CODES_LABELS[value],
  value
}));
export const WAREHOUSE_CODES_OPTIONS_WITHOUT_POSTAL = WAREHOUSE_CODES_OPTIONS.filter(option => option.value !== WarehouseCodes.POSTAL);
export const WarehouseBasedOnDistributionArea = {
  [WarehouseDistributionArea.WestCoast]: WarehouseCodes.BR,
  [WarehouseDistributionArea.EastCoast]: WarehouseCodes.BR,
  [WarehouseDistributionArea.International]: WarehouseCodes.BR,
  [WarehouseDistributionArea.NotAvailable]: WarehouseCodes.BR,
  [WarehouseDistributionArea.USA]: WarehouseCodes.BR
};
export const DistributionAreaLabel = {
  [WarehouseDistributionArea.WestCoast]: 'Mostly the Western US',
  [WarehouseDistributionArea.EastCoast]: 'Mostly the Eastern US',
  [WarehouseDistributionArea.USA]: 'All over the United States',
  [WarehouseDistributionArea.International]: 'International'
};
export const WarehouseAddresses = {
  [WarehouseCodes.ROC]: {
    fnameShipping: 'Complemar ',
    lnameShipping: 'Warehouse',
    address: '500 Lee Road',
    unit: 'Suite 200',
    city: 'Rochester',
    country: COUNTRY_CODES.US,
    state: 'NY',
    zip: '14606',
    company: 'Complemar',
    attentionTo: 'Swag.com (81180)',
    phone: '(585) 647-5800 Option 6'
  },
  [WarehouseCodes.MEC]: {
    fnameShipping: 'Complemar / ',
    lnameShipping: 'Swag',
    address: '1011 Aip Dr',
    unit: '#4',
    city: 'Middletown',
    country: COUNTRY_CODES.US,
    state: 'PA',
    zip: '17057',
    company: 'Complemar',
    attentionTo: 'Swag.com (81180)',
    phone: '(585) 647-5800 Option 6'
  },
  [WarehouseCodes.WHIPLASH]: {
    fnameShipping: 'Whiplash ',
    lnameShipping: 'Warehouse',
    address: '1225 Southgate Parkway',
    unit: '',
    city: 'Etna',
    country: COUNTRY_CODES.US,
    state: 'OH',
    zip: '43062',
    company: 'Whiplash',
    attentionTo: 'Swag, SN 179203',
    phone: ''
  },
  [WarehouseCodes.POSTAL]: {
    fnameShipping: 'Postal ',
    lnameShipping: 'Warehouse',
    address: 'ShipBob C/O Postal 400 Smoke Tree Plaza Suite 100',
    unit: '',
    city: 'North Aurora',
    country: COUNTRY_CODES.US,
    state: 'IL',
    zip: '60542',
    company: 'Postal',
    attentionTo: 'Swag, SN 179203',
    phone: ''
  },
  [WarehouseCodes.BR]: {
    fnameShipping: 'BR Printers ',
    lnameShipping: 'Warehouse',
    address: '5000 N Moline St',
    unit: '',
    city: 'Denver',
    country: COUNTRY_CODES.US,
    state: 'CO',
    zip: '80239',
    company: 'BR Printers',
    attentionTo: 'Swag',
    phone: ''
  }
};
export const SendosoWarehouse = {
  fnameShipping: 'Phoenix ',
  lnameShipping: 'Warehouse',
  address: '100 N 61st Avenue',
  unit: '',
  city: 'Phoenix',
  country: COUNTRY_CODES.US,
  state: 'AZ',
  zip: '85043',
  company: 'Sendoso',
  attentionTo: '',
  phone: '',
  warehouseLocation: null
};
export const PostalWarehouse = {
  fnameShipping: 'Postal ',
  lnameShipping: 'Warehouse',
  address: 'ShipBob C/O Postal 400 Smoke Tree Plaza Suite 100',
  unit: '',
  city: 'North Aurora',
  country: COUNTRY_CODES.US,
  state: 'IL',
  zip: '60542',
  company: 'Postal',
  attentionTo: 'Swag, SN 179203',
  phone: '',
  warehouseLocation: null
};
export let CreditsTransactionTypes = /*#__PURE__*/function (CreditsTransactionTypes) {
  CreditsTransactionTypes["BUY"] = "BUY";
  CreditsTransactionTypes["USE"] = "USE";
  CreditsTransactionTypes["TRANSFER"] = "TRANSFER";
  CreditsTransactionTypes["WITHDRAW"] = "WITHDRAW";
  CreditsTransactionTypes["REFUND"] = "REFUND";
  CreditsTransactionTypes["ADJUSTMENT"] = "ADJUSTMENT";
  return CreditsTransactionTypes;
}({});
export let CreditsTransactionStatuses = /*#__PURE__*/function (CreditsTransactionStatuses) {
  CreditsTransactionStatuses["PENDING"] = "PENDING";
  CreditsTransactionStatuses["FULFILLED"] = "FULFILLED";
  CreditsTransactionStatuses["REJECTED"] = "REJECTED";
  return CreditsTransactionStatuses;
}({});
export let CreditsOrderType = /*#__PURE__*/function (CreditsOrderType) {
  CreditsOrderType["ORDER"] = "ORDER";
  CreditsOrderType["DISTRIBUTION"] = "DISTRIBUTION";
  CreditsOrderType["STORAGE_FEE"] = "STORAGE_FEE";
  return CreditsOrderType;
}({});
export let CreditsOrderPaymentTypes = /*#__PURE__*/function (CreditsOrderPaymentTypes) {
  CreditsOrderPaymentTypes["CREDIT_CARD"] = "CREDIT_CARD";
  CreditsOrderPaymentTypes["BANK_INFO"] = "BANK_INFO";
  CreditsOrderPaymentTypes["ACH"] = "ACH";
  return CreditsOrderPaymentTypes;
}({});